<li class="email-notif-switcher-item__subToggles">
  <div class="email-notif-switcher-item-inner-wrapper">
    <app-email-notification-toggle
      [value]="settings.all.innerToggles.elementComments.toggled"
      label="Element Comments"
      [description]="'When you are mentioned in an element comment'"
      (toggle)="toggleSetting.emit(['all', 'elementComments'])">
    </app-email-notification-toggle>
  </div>
</li>
